import { Injectable } from '@angular/core';
import { FormControl } from '@angular/forms';
@Injectable({
  providedIn: 'root'
})
export class GlobalValidationService {

  constructor() { }

  static checkMobileNumber(control: FormControl): any {
    if (control.hasOwnProperty('_parent')) {
      if (control.value !== null && control.value !== '') {
        const mobile = Math.ceil(Math.log(control.value) / Math.LN10);
        if (mobile > 10) {
          return { 'error': 'Mobile Number Should not be Greater than 10' };
        } else if (mobile < 10) {
          return { 'error': 'Mobile Number Should not be less than 10' };
        } else {
          control._parent.controls.mobile.errors = { 'valid': false };
        }
      }
    }
  }

  static checkPincode(control: FormControl): any {
    if (control.hasOwnProperty('_parent')) {
      if (control.value !== null && control.value !== '') {
        const pincode = Math.ceil(Math.log(control.value) / Math.LN10);
        if (pincode > 6) {
          return { 'error': 'Pincode Should not be Greater than 6' };
        } else if (pincode < 6) {
          return { 'error': 'Pincode Should not be less than 6' };
        } else {
          control._parent.controls.pincode.errors = { 'valid': false };
        }
      }
    }
  }

  static checkAlternateMobileNumber(control: FormControl): any {
    if (control.hasOwnProperty('_parent')) {
      if (control._parent.value.alternate_mobile !== null && control.value !== '') {
        const mobile = Math.ceil(Math.log(control.value) / Math.LN10);
        if (mobile > 10) {
          return { 'error': 'Mobile Number Should not be Greater than 10' };
        } else if (mobile < 10) {
          return { 'error': 'Mobile Number Should not be less than 10' };
        } else {
          control._parent.controls.alternate_phone.errors = { 'valid': false };
        }
      }
    }
  }

  static checkPanNumber(control: FormControl): any {
    if (control.hasOwnProperty('_parent')) {
      if (control._parent.value.pan_number !== null && control.value !== '') {
        const pan_number = Math.ceil(Math.log(control.value) / Math.LN10);
        if (pan_number > 10) {
          return { 'error': 'Pan number Should not be Greater than 10' };
        } else if (pan_number < 10) {
          return { 'error': 'Pan number Should not be less than 10' };
        } else {
          control._parent.controls.pan_number.errors = { 'valid': false };
        }
      }
    }
  }

  static checkAadharNumber(control: FormControl): any {
    if (control.hasOwnProperty('_parent')) {
      if (control._parent.value.aadhar_number !== null && control.value !== '') {
        const aadhar_number = Math.ceil(Math.log(control.value) / Math.LN10);
        if (aadhar_number > 12) {
          return { 'error': 'Aadhar number Should not be Greater than 12' };
        } else if (aadhar_number < 12) {
          return { 'error': 'Aadhar number Should not be less than 12' };
        } else {
          control._parent.controls.aadhar_number.errors = { 'valid': false };
        }
      }
    }
  }


  static checkNomineeAadharNumber(control: FormControl): any {
    if (control.hasOwnProperty('_parent')) {
      if (control._parent.value.nominee_aadhar_number !== null && control.value !== '') {
        const nominee_aadhar_number = Math.ceil(Math.log(control.value) / Math.LN10);
        if (nominee_aadhar_number > 12) {
          return { 'error': 'Aadhar number Should not be Greater than 12' };
        } else if (nominee_aadhar_number < 12) {
          return { 'error': 'Aadhar number Should not be less than 12' };
        } else {
          control._parent.controls.nominee_aadhar_number.errors = { 'valid': false };
        }
      } else {
            control._parent.controls.nominee_aadhar_number.errors = { 'valid': false };
          }
    }
  }

  static checkNomineeMobileNumber(control: FormControl): any {
    if (control.hasOwnProperty('_parent')) {
      if (control.value !== null && control.value !== '') {
        const nominee_phone = Math.ceil(Math.log(control.value) / Math.LN10);
        if (nominee_phone > 10) {
          return { 'error': 'phone Number Should not be Greater than 10' };
        } else if (nominee_phone < 10) {
          return { 'error': 'phone Number Should not be less than 10' };
        } else {
          control._parent.controls.nominee_phone.errors = { 'valid': false };
        }
      }
    }
  }

}
